/**
 * This file is auto-generated from ChatMessageImageTile.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import { pluralizationEn, pluralizationPl, type Translation, type PluralTranslation } from '@nzyme/i18n-core';

const moreOverflow_en: PluralTranslation<typeof pluralizationEn, { count: number }> = {
    one: params => ['+', params.count, ' more'],
    many: params => ['+', params.count, ' more'],
};

const moreOverflow_pl: PluralTranslation<typeof pluralizationPl, { count: number }> = {
    one: params => ['+', params.count, ' więcej'],
    few: params => ['+', params.count, ' więcej'],
    many: params => ['+', params.count, ' więcej'],
};

export const moreOverflow: Translation<{ count: number }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return pluralizationEn.pluralize(params.count, moreOverflow_en)?.(params);
        case 'pl':
            return pluralizationPl.pluralize(params.count, moreOverflow_pl)?.(params);
    }
};

export const imageAttachment: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Image attachment';
        case 'pl':
            return 'Załącznik obrazu';
    }
};

const showMoreImages_en: PluralTranslation<typeof pluralizationEn, { count: number }> = {
    one: params => ['Show ', params.count, ' more image'],
    many: params => ['Show ', params.count, ' more images'],
};

const showMoreImages_pl: PluralTranslation<typeof pluralizationPl, { count: number }> = {
    one: params => ['Pokaż ', params.count, ' kolejny obraz'],
    few: params => ['Pokaż ', params.count, ' kolejne obrazy'],
    many: params => ['Pokaż ', params.count, ' kolejnych obrazów'],
};

export const showMoreImages: Translation<{ count: number }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return pluralizationEn.pluralize(params.count, showMoreImages_en)?.(params);
        case 'pl':
            return pluralizationPl.pluralize(params.count, showMoreImages_pl)?.(params);
    }
};
